import * as Models from "../ts/rlAdmin.models";
import { NotifyService } from "../services/notify-service";
import { IFacetFilter } from "../ts/rlAdmin.filters";

export class BaseAssociationSearchController<T> {

    initialized: boolean;		// initialized flag
    keywords: string;			// search keywords
    itemRows: T[];			    // search result item rows
    page: number;				// current page
    pageCount: number;			// current page	count of search	results
    qTime: number;				// time	in ms of search	operation
    jumpTo: number;				// jump-to input value
    selectedStatus: string;		// current selected	status
    selectedTemplate: string;	// current selected	template
    templates: Models.IKeyValuePair<string, number>[];			// template	data for select	box
    templateFacets: Models.IKeyValuePair<string, string>[];
    statuses: Models.IKeyValuePair<string, number>[];			// status data for select box
    statusFacets: Models.IKeyValuePair<string, string>[];			// status data for select box
    workflowActions: Models.IKeyValuePair<string, number>[];	// available workflow actions
    selectedAction: string;		// selected	workflow action
    sortField: string;			// sort by field (matches a solr field)
    sortDir: number;				// sort by direction.  0 - asc, 1 - desc
    allChecked: boolean;
    selectedItems: { [key: string]: boolean };
    numFound: number;
    showClear: boolean;
    relatedToMe: boolean;

    constructor(private $baseScope: ng.IScope, $baseLocation: ng.ILocationService, private $baseFilter: ng.IFilterService, private baseNotifyService: NotifyService) {
        this.initialized = false;		// initialized flag
        this.keywords = "";			// search keywords
        this.itemRows = [];			// search result item rows
        this.page = 1;				// current page
        this.pageCount = 1;			// current page	count of search	results
        this.numFound = 0;
        this.qTime = 0;				// time	in ms of search	operation
        this.jumpTo = 1;				// jump-to input value
        this.selectedStatus = null;		// current selected	status
        this.selectedTemplate = null;	// current selected	template
        this.templates = [];			// template	data for select	box
        this.templateFacets = [];
        this.statuses = [];			// status data for select box
        this.workflowActions = [];	// available workflow actions
        this.selectedAction = "";		// selected	workflow action
        this.sortField = "";			// sort by field (matches a solr field)
        this.sortDir = 0;				// sort by direction.  0 - asc, 1 - desc
        this.allChecked = false;
        this.selectedItems = {};
        this.showClear = false;
        this.relatedToMe = this.relatedToMe || false;

        $baseScope.$watch(() => this.templates,
            (newValue: Models.IKeyValuePair<string, number>[], oldValue: Models.IKeyValuePair<string, number>[]) => {
                if (newValue != oldValue) {
                    this.templateFacets = $baseFilter<IFacetFilter>("facetFilter")(newValue);
                }
            }, true);

        $baseScope.$watch(() => this.statuses,
            (newValue: Models.IKeyValuePair<string, number>[], oldValue: Models.IKeyValuePair<string, number>[]) => {
                if (newValue != oldValue) {
                    this.statusFacets = $baseFilter<IFacetFilter>("facetFilter")(newValue);
                }
            }, true);

        // if template changed, reset status
        $baseScope.$watch(() => this.selectedTemplate, (newValue: string, oldValue: string) => {
            if (newValue != oldValue) {
                this.selectedStatus = null;
            }
        });

        // if template or status changed, reset page to 1
        $baseScope.$watch(() => [this.selectedStatus, this.selectedTemplate],
            (newValue: any[], oldValue: any[]) => {
                this.page = 1;
            }, true);

        // if template, status, page, sortDir, or sortField changes, update search
        $baseScope.$watch(() => [this.page, this.selectedStatus, this.selectedTemplate, this.sortDir, this.sortField, this.relatedToMe],
            (newValue: any[], oldValue: any[]) => {
                if (newValue != oldValue) {
                    this.PushState();
                }
            }, true);

        $baseScope.$watch<string[]>(() => [this.keywords, this.selectedStatus, this.selectedTemplate],
            (newValue, oldValue) => {
                this.showClear = _.any(newValue, (val) => !_.isEmpty(val));
            }, true);

        // responsd	to any change in the url hash
        $baseScope.$watch(
            () => $baseLocation.url(),
            () => {
                var search = $baseLocation.search();

                this.keywords = search.k || "";
                this.page = _.parseInt(search.p || 1);
                this.selectedStatus = search.s || null;
                this.selectedTemplate = search.t || null;
                this.sortField = search.sf || "";
                this.sortDir = _.parseInt(search.sd || 0);
                this.relatedToMe = _.parseInt(search.rtm || 0) > 0;
                this.Search();
            });
    }

    Search(): void {
        throw "Implement this.Search";
    }

    // fired when search button	is clicked
    SearchSubmit() {
        //$event.preventDefault();
        this.page = 1;				// reset page
        this.selectedItems = {};	// reset selected contacts
        this.PushState();				// push	state
    }

    // push	search state to	the	url	hash
    PushState() {
        //var newState = { k: this.keywords, t: this.selectedTemplate || "", s: this.selectedStatus || "", p: this.page, sf: this.sortField || "", sd: this.sortDir || 0, rtm: this.relatedToMe ? 1 : 0 };
        //this.$baseLocation.search(newState);
    }

    ClearSearch($event: ng.IAngularEvent) {
        $event.preventDefault();

        this.keywords = "";
        this.selectedTemplate = null;
        this.selectedStatus = null;
        this.page = 1;
        this.sortField = "";
        this.sortDir = 0;
        this.selectedAction = "";
        this.selectedItems = {};
        this.relatedToMe = false;
        this.PushState();
    }
}